


// Custom theme scripts

// =========================================================
// ✅ GLOBAL CONFIGURATION: CHANGE THESE TWO VALUES!
// =========================================================
const CONTAINER_SIZE = 200; // The width and height of the whole container in pixels
const STROKE_WIDTH = 30;    // The thickness of the progress line
// =========================================================

const COUNTER_CONFIG = {
    one: 95,
    two: 87,
    three: 99
};
const ANIMATION_DURATION = 2000; // 2000ms (2 seconds)
// Fix: Minimum offset is set equal to the stroke width to prevent rounded caps from merging
const MIN_GAP_PIXELS = STROKE_WIDTH;

// --- Dynamic Calculations ---
// R = (Size - Stroke) / 2
const RADIUS = (CONTAINER_SIZE - STROKE_WIDTH) / 2;
// C = 2 * PI * R
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
// Center (CX, CY) is Size / 2
const CENTER = CONTAINER_SIZE / 2;
// ViewBox is always 0 0 [Size] [Size]
const VIEWBOX = `0 0 ${CONTAINER_SIZE} ${CONTAINER_SIZE}`;
// ----------------------------

// Function to animate a single progress circle
function animateProgress(container) {
    const dataId = container.getAttribute('data-id');
    const targetPercent = COUNTER_CONFIG[dataId];

    if (targetPercent === undefined) return;

    // Calculate the initial offset based on the target percentage
    let calculatedOffset = CIRCUMFERENCE * (1 - (targetPercent / 100));

    // Enforce the minimum gap for non-100% values
    if (targetPercent < 100) {
        calculatedOffset = Math.max(calculatedOffset, MIN_GAP_PIXELS);
    }

    const targetOffset = calculatedOffset;

    const svgElement = container.querySelector('svg');
    const valueDisplay = container.querySelector('.progress-text');

    // 1. Configure Container and SVG elements
    container.style.width = `${CONTAINER_SIZE}px`;
    container.style.height = `${CONTAINER_SIZE}px`;
    svgElement.setAttribute('viewBox', VIEWBOX);

    // 2. Create and Append the Circle
    const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    circle.setAttribute('class', 'circle-progress');
    circle.setAttribute('cx', CENTER);
    circle.setAttribute('cy', CENTER);
    circle.setAttribute('r', RADIUS);
    // Set initial state for the animation
    circle.style.strokeDasharray = CIRCUMFERENCE;
    circle.style.strokeDashoffset = CIRCUMFERENCE;
    // Set the dynamic stroke width
    circle.style.strokeWidth = STROKE_WIDTH;

    svgElement.appendChild(circle);

    // 3. Start the Animation (Timeout ensures the circle is added to the DOM first)
    setTimeout(() => {
        // Animate the Circle
        circle.style.strokeDashoffset = targetOffset;

        // Animate the Counter Number
        let current = 0;
        const stepTime = ANIMATION_DURATION / targetPercent;

        const counter = setInterval(() => {
            current += 1;
            valueDisplay.textContent = `${current}%`;

            if (current >= targetPercent) {
                valueDisplay.textContent = `${targetPercent}%`;
                clearInterval(counter);
            }
        }, stepTime);
    }, 50); // Small delay
}

// Run the setup and animation for all circles when the window loads
window.addEventListener('load', () => {
    // ✅ Updated the selector to the unique, theme-specific class
    const allCircles = document.querySelectorAll('.swedish-progress-circle-wrapper');

    allCircles.forEach(circle => {
        animateProgress(circle);
    });
});



/* SECTION: Before & After Image */

const sliderHandle = document.querySelector("#sliderHandle");
const sliderLine = document.querySelector(".slider-line");
const beforeImage = document.querySelector(".before-image");
const afterImage = document.querySelector(".after-image");
const sliderContainer = document.querySelector(".slider-container");
let isDragging = false;
const initializeSlider = () => {
    const containerWidth = sliderContainer.offsetWidth;
    sliderHandle.style.transition = "left 0.3s ease";
    sliderLine.style.transition = "left 0.3s ease";
    sliderHandle.style.left = "50%";
    sliderLine.style.left = "50%";
    beforeImage.style.clipPath = `inset(0 50% 0 0)`;
    afterImage.style.clipPath = `inset(0 0 0 50%)`;
};
const moveSlider = (clientX) => {
    const containerRect = sliderContainer.getBoundingClientRect();
    let offsetX = clientX - containerRect.left;
    if (offsetX < 0) offsetX = 0;
    if (offsetX > containerRect.width) offsetX = containerRect.width;
    const percentage = Math.round((offsetX / containerRect.width) * 100);
    sliderHandle.style.left = `${percentage}%`;
    sliderLine.style.left = `${percentage}%`;
    beforeImage.style.clipPath = `inset(0 ${100 - percentage}% 0 0)`;
    afterImage.style.clipPath = `inset(0 0 0 ${percentage}%)`;
};
const startDragging = () => {
    isDragging = true;
    sliderHandle.style.transition = "none";
    sliderLine.style.transition = "none";
};
const stopDragging = () => {
    isDragging = false;
    sliderHandle.style.transition = "left 0.3s ease";
    sliderLine.style.transition = "left 0.3s ease";
};
sliderHandle.addEventListener("mousedown", startDragging);
sliderLine.addEventListener("mousedown", startDragging);
window.addEventListener("mousemove", (event) => {
    if (isDragging) {
        moveSlider(event.clientX);
    }
});
window.addEventListener("mouseup", stopDragging);
sliderHandle.addEventListener("touchstart", startDragging);
sliderLine.addEventListener("touchstart", startDragging);
window.addEventListener("touchmove", (event) => {
    if (isDragging) {
        moveSlider(event.touches[0].clientX);
    }
});
window.addEventListener("touchend", stopDragging);
window.addEventListener("load", initializeSlider);